module.exports = __webpack_public_path__ + "static/media/matching-score-rank-0.ce55711f.png";